export const NAV_DRAWER_CLASSNAME = "nav-drawer"

export function getProfilePopoverRoot() {
  const navDrawer = document.querySelector(`.${NAV_DRAWER_CLASSNAME}`)

  if (!navDrawer) {
    return undefined
  }

  return navDrawer as HTMLElement
}
